import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { imageProcessing } from "src/app/utils/image-processing-utils";
import { getFileNameFromUrl, onDateChange } from "src/app/utils/utils.common";
import { ProTipsServiceService } from "../../helping-material/nemt-pro-tips/service/pro-tips-service.service";

@Component({
  selector: "app-fleet-credentials",
  templateUrl: "./fleet-credentials.component.html",
  styleUrls: ["./fleet-credentials.component.css"],
})
export class FleetCredentialsComponent implements OnInit {
  fleetForm: FormGroup;
  isSubmitted = false;
  constructor(
    private fb: FormBuilder,
    private proTips : ProTipsServiceService
    ) {}

  ngOnInit() {
    this.fleetForm = this.fb.group({
      license: this.fb.group({
        imageURL: [""],
        licenseNumber: ["", Validators.required],
        isRequired: [false],
        preIssueDate: [""],
        preExpiryDate: [""],
        issueDate: ["", Validators.required],
        expiryDate: ["", Validators.required],
      }),
      vehicleFront: this.getFormGroup(),
      vehicleBack: this.getFormGroup(),
      vehicleLeft: this.getFormGroup(),
      vehicleRight: this.getFormGroup(),
      registration: this.getFormGroup(),
      inspection: this.getFormGroup(),
    });
  }

  getFormGroup() {
    return this.fb.group({
      imageURL: [""],
      preDate: [""],
      date: [""],
    });
  }


  onSubmit() {
    this.isSubmitted = true;
    const payload = this.fleetForm.value;
  }

  getFileName(url) {
    return getFileNameFromUrl(url);
  }

  onDateChange(event, control) {
    onDateChange(event, control);
  }
  async fileProcessing(ImageInput, form) {
    imageProcessing(ImageInput)
     .subscribe(async (result) => {
      const data:any =  await this.proTips.changeCoverImage(result.file).toPromise();
      form.setValue(data.location);
    })
  
    }
  
  get form(){
    return this.fleetForm.controls;
  }
}
